/*eslint no-script-url: 0 */
import React, { Component } from "react";

export default class ResetImage extends Component {

	constructor(props, context) {
		super(props, context);
		this.resetImage = this.resetImage.bind(this);
	}

	resetImage() {
		this.props.handler(this.props.id, '', '');
	}

 	render() {
	    return (
	    	<li className="m-b-5">
				<a href="#!" onClick={this.resetImage} className="btn btn-danger text-upper">Reset Image</a>
			</li>
	    );
  	}
}